const ClassInfo = ({ _data, handelEdit, handelDelete }) => {
  return (
    <div
      className="flex-col align-left jutify-start g-2 radius-10 back-white p-2"
      style={{ width: "20rem" }}
    >
      <h3 className="t-17 poppins-medium color-textColor weight-500">
        Class: {_data?.class}
      </h3>
      <div className="flex-col align-left justify-start w-full g-1">
        <div className="flex-col align-left justify-start w-full g-05">
          <div className="flex-row align-center justify-start g-05">
            <span className="t-14 poppins color-textColor">
              Number of Sections:
            </span>
            <span className="t-14 poppins color-greenColor">
              {_data?.sections}
            </span>
          </div>
          <div className="flex-row align-center justify-start g-05">
            <span className="t-14 poppins color-textColor">Board:</span>
            <span className="t-14 poppins color-greenColor">
              {_data?.board}
            </span>
          </div>
          <div className="flex-row align-center justify-start g-05">
            <span className="t-14 poppins color-textColor">Affiliated by:</span>
            <span className="t-14 poppins color-greenColor">
              {_data?.affiliationList?.map((item, index) => {
                const isLast = index === _data?.affiliationList?.length - 1;
                return (
                  <>
                    {item}
                    {isLast ? "" : ","}
                  </>
                );
              })}
            </span>
          </div>
          <div className="flex-row align-center justify-start g-05">
            <span className="t-14 poppins color-textColor">Mode:</span>
            <span className="t-14 poppins color-greenColor">{_data?.mode}</span>
          </div>
          <div className="flex-row align-center justify-start g-05">
            <span className="t-14 poppins color-textColor">
              Number of seats:
            </span>
            <span className="t-14 poppins color-greenColor">
              {_data?.totalSeats}
            </span>
          </div>
        </div>
        <div className="flex-col align-center justify-start w-full g-05">
          <button
            type="button"
            onClick={handelEdit}
            className="actionBtn w-full"
          >
            Edit
          </button>
          <button
            type="button"
            onClick={() => handelDelete(_data)}
            className="deleteBtnFill w-full"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClassInfo;
